import { render, staticRenderFns } from "./DbfScorecardComment.vue?vue&type=template&id=f308b30a&scoped=true"
import script from "./DbfScorecardComment.vue?vue&type=script&lang=js"
export * from "./DbfScorecardComment.vue?vue&type=script&lang=js"
import style0 from "./DbfScorecardComment.vue?vue&type=style&index=0&id=f308b30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f308b30a",
  null
  
)

export default component.exports